import React, { useState, useEffect } from 'react'
import NavbarUser from '../../../../components/navbar/NavbarUser';
import ViewDocuments from '../veiwdocuments/viewDocuments'
import FetchApi from '../../../customhooks/Functionapi';
import {ApprovedSend} from'../../component/aprovedStatusAll/ApprovedFunction';
import {
    useParams, useNavigate
} from "react-router-dom";
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import'./newdocument.scss';
import Swal from 'sweetalert2';


const d = new Date();
let  convertdate=""
let convertmonth=d.getMonth()+1;
if(d.getDate() <10){
  convertdate="0"+d.getDate();
}
else{
    convertdate=d.getDate();
}
if(d.getMonth()+1<10){
  convertmonth="0"+convertmonth
}else{
    convertmonth=convertmonth
}
var timestampsnow=d.getFullYear()+"-"+convertmonth+"-"+convertdate+" "+d.getHours()+":"+d.getMinutes()+":"+d.getSeconds();
var timestampsDate=d.getFullYear()+"-"+convertmonth+"-"+convertdate;



function SendStatus(props) {
    let { id } = useParams(); //journalID
    const navigate = useNavigate();
    const FetchApis = new FetchApi();
    const userId = sessionStorage.getItem("userId")
    const [datajournal, sertDatajournal] = useState([]);
    const [flowStatus, setFlowStatus] = useState("");
    const [flowStateEnd, setFlowStateEnd] = useState("");


    useEffect(() => {
        getJournalbyId()
    }, [])
    const getJournalbyId = () => {

        FetchApis.FethcGet(`/document/DocumentById/${id}`).then(res => {
            if (res) {

                sertDatajournal(res.data)
                getFlowstatus(res.data)
            }

        })
    }


    const getFlowstatus = (data) => {

        FetchApis.FethcPost(`/flowrunsystem/flowrunByUserId`, {
            journalId: id,
            stateflow: data[0].stateflow,
            UserId: userId
        }).then(res => {

            if (res.data.length > 0) {
                setFlowStatus(res.data[0].statusType)
                setFlowStateEnd(res.data[0].stateEnd)
            }

        })
    }

    const isAPPROVED = () => {

        Swal.fire({
            title: "แจ้งเตือน",
            text: "คุณต้องการบันทึก ส่งข้อมูล ใช่หรือไม่ ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "บันทึก",
            cancelButtonText: "ยกเลิก"
        }).then((result) => {
            if (result.isConfirmed) {

                ApprovedSend(datajournal, userId, flowStatus, flowStateEnd,timestampsnow).then(res => {
                    if (res.status == 200) {

                        Swal.fire({
                            title: "แจ้งการบันทึก",
                            text: "คุณทำการบันทึกเรียบร้อยแล้ว",
                            icon: "success"
                        });

                        setTimeout(() => {
                            window.location.href = '/documents'
                        }, 1000);
                    }
                })

            }
        });

    }

    return (
        <div className='nd-page' style={{ backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
            <NavbarUser />
            <div className='nd-toolbar'>
                <div>
                    <div className='nd-toolbar-title'>ส่งเอกสารเข้าระบบอนุมัติ</div>
                    <div className='nd-toolbar-sub'>
                        {datajournal.length > 0 ? `เลขที่เอกสาร ${datajournal[0].JournalCode} · ตรวจสอบข้อมูลก่อนกดส่ง` : 'กำลังโหลดข้อมูลเอกสาร...'}
                    </div>
                </div>
                <div className='nd-toolbar-actions'>
                    <Button variant="outlined" color='inherit' startIcon={<ArrowBackIosNewIcon />} onClick={() => navigate(-1)}>กลับ</Button>
                    <Button variant="contained" color="success" startIcon={<SendIcon />} onClick={() => isAPPROVED()}>ส่งข้อมูล</Button>
                </div>
            </div>
            <ViewDocuments jourID={id} cardLayout={true} />
        </div>
    )
}

export default SendStatus